import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Link from '@zenbusiness/zui/Link';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { login } from '#client/constants/routes';

import { PaymentReturnHeaderRoot } from './PaymentReturnHeader.style';

import { HELP_URL, ZB_LOGO_SRC } from '../../constants';

export default function PaymentReturnHeader() {
  return (
    <PaymentReturnHeaderRoot>
      <Link to="/dashboard">
        <SharedAsset alt="ZenBusiness Inc." src={ZB_LOGO_SRC} width={44} />
      </Link>
      <Stack direction="row" gap={2} alignItems="center">
        <Link href={HELP_URL} target="_blank" rel="noopener noreferrer" underline="hover">
          <Text size="sm" color="secondary">
            <FormattedMessage id="dashboard.paymentReturn.header.needHelp" />
          </Text>
        </Link>
        <Link to={login} underline="hover">
          <Text size="sm" weight="bold">
            <FormattedMessage id="dashboard.paymentReturn.header.logIn" />
          </Text>
        </Link>
      </Stack>
    </PaymentReturnHeaderRoot>
  );
}
